module.exports = __webpack_public_path__ + "img/PrivacyAwarenessTraining.1e7aad00.jpg";